export function formatFileSizeBytes(size: number): string {
  if (!Number.isFinite(size) || size <= 0) return '0 B'

  const units = ['B', 'KB', 'MB', 'GB', 'TB']
  let value = size
  let unitIdx = 0

  while (value >= 1024 && unitIdx < units.length - 1) {
    value /= 1024
    unitIdx += 1
  }

  const rounded = value >= 100 ? value.toFixed(0) : value.toFixed(1)
  return `${rounded} ${units[unitIdx]}`
}
